import styled from "styled-components";

export const HangarNumber = ({ hangar = "" }) => {
	return (
		<Container>
			<HangarText>Hangar number</HangarText>
			<HangarCode>{hangar}</HangarCode>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
`;

const HangarText = styled.span`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	color: #595959;
`;

const HangarCode = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	margin-left: 4px;
`;
